module.exports = __webpack_public_path__ + "media/images/clientes-cuenta-general-color-3758f9d890ddda753026157926940f2d.png";